import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { URLS } from 'src/app/_config/api.config';
import { ApiService } from 'src/app/services/api-data.service';
import { CommonService } from 'src/app/services/common.service';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, switchMap, throttleTime } from 'rxjs/operators';
import { CustomValidator } from 'src/app/_common/custom-validators';
import { BequestCardDataService } from 'src/app/shared/bequest-card-data.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-charities',
  templateUrl: './charities.component.html',
  styleUrls: ['./charities.component.scss']
})
export class CharitiesComponent implements OnInit {

   @ViewChild('openChartityModalButton') openChartityModalButton;
   @Output() messageEvent = new EventEmitter<any>();
   @Output() largeCardData = new EventEmitter<any>();
   @Output() smallCardData = new EventEmitter<any>();
   
  private mutationObserver: MutationObserver | null = null;
   addAnotherCharityActive=false;
   charityForm!: FormGroup;
   organizationTypes = ['Non-Profit', 'Religious', 'Educational', 'Medical'];
   cities = ['New York', 'Washington DC'];
   states = ['Texas', 'Florida', 'Alaska'];
   page=1;
   size=8;
  @ViewChild('charityDescEl') charityDescEl!: ElementRef<HTMLDivElement>;
  expanded = false;
  showToggle = false;
  private resizeObserver: ResizeObserver | null = null;

  showLoadMoreButton=true;
  searching=false;

  searchText: string = '';
	searchTextVal: string = '';
	searchTerm: string = '';

	favCharityNameList: any = [];
	selectedOrganizationType = 'Select';
	isOpen = false;
	isEditDisabled = false;
	charityCategoryList = [];
  listenerInitialized = false;
  searchControl = new FormControl('');
  searchSub: Subscription | null = null;
  organizationTypeId: any;
  orgId: any;
  addCharityOrgId: any = null;
  showNoResult = false;
  charityLoading=false;
  @Input() selectedCharitiesData:any;
  @Input() isView:any;
  loadingMoreCharity=false
   //
   private subscription: Subscription = new Subscription()

  constructor(private fb: FormBuilder,
     private dataService: ApiService,
            private toastr: ToastrService,
            private route: ActivatedRoute,
            private sanitizer: DomSanitizer,
            private elRef: ElementRef,
            public commonService: CommonService,
            private customCharityCard: BequestCardDataService
  ) { }

  featuredCharity: any;
  charities: any;
  modalSizeClass = 'modal-xl'; // default

  //infintie scroll variable declaration below
  search$ = new Subject<string>();
  scroll$ = new Subject<void>();

  pageSize = 5;
  currentPage = 1;
  currentSearchTerm = '';

  loading = false;
  allLoaded = false;


  ngOnInit(): void {
     this.customCharityCard.dataArray$.subscribe(data => {
      // this.custCharityCardData = data;\
      this.charities=data;
      if(this.selectedCharitiesData && !this.customCharityCard.isCardDeletedRecently())
      this.charities = this.reorderCharities(this.selectedCharitiesData, this.charities);
    });

    this.charityForm = this.fb.group({
          charityName: ['', [Validators.required, CustomValidator.noWhiteSpaceValidator]],
          organizationType: ['', [Validators.required]],
          city: ['', [Validators.required, CustomValidator.nameValidator, CustomValidator.noWhiteSpaceValidator]],
          state: ['', [Validators.required, CustomValidator.nameValidator, CustomValidator.noWhiteSpaceValidator]],
        });
    this.getCharities();
    this.getCharityCategoryList();
    this.customCharityCard.mergeDeletedItemsIntoStoredData();

    //infinite scroll code below
   this.search$.pipe(
  debounceTime(500),
  distinctUntilChanged(),
  filter(term => term.trim().length > 0),
  switchMap(term => {
    this.currentSearchTerm = term;
    this.currentPage = 1;
    this.favCharityNameList = [];
    this.allLoaded = false;
    this.loading = true;

    // ✅ Return the observable
    return this.getFavCharitySearch({ search: term, page: this.currentPage, size: this.pageSize });
  })
).subscribe(({ results, totalCount }) => {
  this.favCharityNameList = results;
  this.allLoaded = results.length >= totalCount;
  this.showNoResult = results.length === 0;
  this.loading = false;
});

  // SCROLL STREAM
  this.scroll$.pipe(
    throttleTime(500),
    filter(() => !this.loading && !this.allLoaded),
    switchMap(() => {
      this.currentPage += 1;
      this.loading = true;
      return this.getFavCharitySearch({ search: this.currentSearchTerm, page: this.currentPage, size: this.pageSize });
    })
  ).subscribe(({ results, totalCount }) => {
    this.favCharityNameList = [...this.favCharityNameList, ...results];
    this.allLoaded = this.favCharityNameList.length >= totalCount;
    this.loading = false;
  });
  
  }

  charity = {
    name: 'National Centre for Padre Pio',
    location: 'Austin, Texas',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus venenatis elementum suscipit. Nunc at diam sit amet augue gravida aliquet at in eros.',
    ein: '12-3456789',
    coverImage: '../../../../assets/images/green-grass.jpg',
    logo: '../../../../assets/images/charity-logo.svg',
    category: 'Category',
    about: '',
    website: 'www.Loremipsumcharity.com',
    color: '',
    categoryIcon: '',
    orgId: '',
  }

openCharityDetail(size: 'lg' | 'xl', addAnotherCharity?, selectedCharity?, charitySelected?) {
  this.showNoResult=false;
  this.searching=false;
  this.modalSizeClass = size === 'lg' ? 'modal-lg' : 'modal-xl';
  if(size=='xl'){
    this.charity.name=this.featuredCharity.orgName;
    this.charity.location= this.featuredCharity?.orgAdderess;
    this.charity.description= this.featuredCharity?.orgParternshipDescription;
    this.charity.ein= this.featuredCharity.orgEinNumber;
    this.charity.coverImage=this.featuredCharity.orgBannerImage;
    this.charity.logo=this.featuredCharity.orgLogo;
    this.charity.category=this.featuredCharity.categoryName;
    this.charity.about=this.featuredCharity.aboutUs;
    this.charity.website=this.featuredCharity.orgWebUrl;
    this.charity.color=this.featuredCharity.categoryColour;
    this.charity.orgId=this.featuredCharity.orgId;
    this.charity['categoryIcon']=this.featuredCharity.categoryIcon
  }
  if(size=='lg' && !addAnotherCharity){
    this.charity.name=selectedCharity.orgName;
    this.charity.location= `${selectedCharity.orgCity}, ${selectedCharity.orgState}`;
    this.charity.description= selectedCharity.orgParternshipDescription;
    this.charity.ein= selectedCharity.orgEinNumber;
    this.charity.coverImage=selectedCharity.orgBannerImage;
    this.charity.logo=selectedCharity.orgLogo;
    this.charity.category=selectedCharity.categoryName;
    this.charity.about=selectedCharity?.aboutUs;
    this.charity.website=selectedCharity.orgWebUrl;
    this.charity.color=selectedCharity.categoryColour;
    this.charity.orgId=selectedCharity.orgId;
    this.charity['categoryIcon']=selectedCharity.categoryIcon
  }
  if(!charitySelected)
  this.openChartityModalButton.nativeElement.click();
  if(addAnotherCharity){
   this.addAnotherCharityActive=true;
   this.charityForm.reset();
   this.searchText='';
   this.addCharityOrgId=null;
   this.charityForm.controls['city'].enable();
   this.charityForm.controls['state'].enable();
   this.charityForm.controls['organizationType'].enable();
  }
  
  // then programmatically open modal if needed
}

getCharityCategoryList() {
  let params = {
  }
  // this.isLoading = true;
  this.subscription.add(
    this.dataService.get(URLS.getcharityCategory, params).subscribe(data => {
      if (data['code'] == 200) {
        if (data['data']) {
          this.charityCategoryList = data['data'];
        }
      } else {
        this.toastr.error(data['message'], "Error");
        // this.isLoading = false;
      }
    }, error => {
      this.toastr.error(error['message'], "Error");
      // this.isLoading = false;
    })
  )
}

sendData() {
 let data= {
   category: this.charity.category,
   ein: this.charity.ein,
   image: this.charity.logo,
   name: this.charity.name,
   categoryIcon: this.charity.categoryIcon,
   categoryColor: this.charity.color,
   orgId: this.charity.orgId
  }
  this.customCharityCard.cardNotDeleted();
  this.customCharityCard.deleteCardData();
  this.messageEvent.emit(data);
   
}

onSubmit(): void {
 if(this.charityForm.controls['charityName'].value==null)
  this.charityForm.controls['charityName'].setValue(this.searchText);
  if (this.charityForm.valid) {
      let data= {
      // category: this.charity.category,
      // ein: this.charity.ein,
      // image: this.charity.logo,
      name: this.charityForm.controls['charityName'].value,
      // city: this.charityForm.controls['city'].value,
      // state: this.charityForm.controls['state'].value,
      // categoryIcon: this.charity.categoryIcon,
      // categoryColor: this.charity.color,
      orgId: this.addCharityOrgId==null ? 'customCharity': this.addCharityOrgId,
     }
     if(this.addCharityOrgId ==null)
      {
      data['city'] = this.charityForm.controls['city'].value;
      data['state'] = this.charityForm.controls['state'].value;
      data['categoryName'] = this.charityForm.controls['organizationType'].value.name;
      data['charitableCategoryId'] = this.charityForm.controls['organizationType'].value._id;
      }
     this.customCharityCard.setCityState(this.charityForm.controls['city'].value,this.charityForm.controls['state'].value);
     this.customCharityCard.cardNotDeleted();
     this.messageEvent.emit(data);
     this.addAnotherCharityActive=false;
     if(data.orgId != 'customCharity' && (this.selectedCustomCharityAlldata?.orgId || this.selectedCustomCharityAlldata?._id) && (data.orgId==this.selectedCustomCharityAlldata.orgId || data.orgId==this.selectedCustomCharityAlldata._id)){
      this.customCharityCard.setCardData(this.selectedCustomCharityAlldata);
     }
    // this.messageEvent.emit(this.charityForm.value);
  } else {
    this.charityForm.markAllAsTouched();
  }
}

modalCanceled(){
  this.search$.next(''); 
  this.closeDropdown();
  setTimeout(() => {
    this.addAnotherCharityActive=false;
  }, 100);
}

  giftCharityClicked() {
    // Close the modal and ensure backdrop is removed
    const modalElement = document.getElementById('charityDetailModal');
    if (modalElement) {
      // Get the Bootstrap modal instance
      const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        // Hide the modal
        modal.hide();
        
        // Force remove backdrop and clean up
        setTimeout(() => {
          // Remove any remaining backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => backdrop.remove());
          
          // Remove modal-open class from body
          document.body.classList.remove('modal-open');
          document.body.style.paddingRight = '';
          
          // Remove show class from modal
          modalElement.classList.remove('show');
          modalElement.style.display = 'none';
          modalElement.setAttribute('aria-hidden', 'true');
          modalElement.removeAttribute('aria-modal');
          
          // Send data after cleanup
          this.sendData();
        }, 100);
      } else {
        // Fallback if modal instance not found
        this.sendData();
      }
    } else {
      // Fallback if modal element not found
      this.sendData();
    }
  }

  giftCharityFromCard(charity: any) {
    // This method is for gift buttons on the main page (not in modal)
    // Set the charity data and then send it
    this.charity.name = charity.orgName;
    this.charity.location = `${charity.orgCity}, ${charity.orgState}`;
    this.charity.description = charity.orgParternshipDescription;
    this.charity.ein = charity.orgEinNumber;
    this.charity.coverImage = charity.orgBannerImage;
    this.charity.logo = charity.orgLogo;
    this.charity.category = charity.categoryName;
    this.charity.about = charity?.aboutUs;
    this.charity.website = charity.orgWebUrl;
    this.charity.color = charity.categoryColour;
    this.charity.orgId = charity.orgId;
    this.charity['categoryIcon'] = charity.categoryIcon;
    
    this.sendData();
  }


getCharities() {
  this.charityLoading=true;
    this.subscription.add(
      this.dataService.get(URLS.getCharities + `?page=${this.page}&size=${this.size}`).subscribe(data => {
        if (data['code'] == 200) {
          this.featuredCharity = data['data']['largeCard'];
          // this.customCharityCard.setData(data['data']['smallCards']);
          //
          this.customCharityCard.setFeaturedCardData(this.featuredCharity);
          const apiData = data['data']['smallCards'] || [];

          this.customCharityCard.dataArray$.pipe(take(1)).subscribe(localData => {
            const apiCharityIds = apiData
              .filter(item => !!item.customCharityId)
              .map(item => item.customCharityId);

            const filteredLocal = localData.filter(local => {
              const isCustom = !!local.customCharityId;
              const isReplacedByApi = isCustom && apiCharityIds.includes(local.customCharityId);

              // Only apply orgId duplication check for items that are NOT custom
              const isDuplicateOrgId =
                !isCustom && apiData.some(api => api.orgId === local.orgId);

              return !isReplacedByApi && !isDuplicateOrgId;
            });

            const updated = filteredLocal.filter(
              item => !(item.orgId === this.featuredCharity['orgId'])
            );//remove the large card data if present from localStorage in Small card array.

            const merged = [...apiData, ...updated];
            this.customCharityCard.setData(merged);
          });
          //
          // this.charities = data['data']['smallCards'];
          this.largeCardData.emit(this.featuredCharity);
          this.smallCardData.emit(this.charities);
          // if (this.charities?.length) {
          //   const idsToDelete = this.charities
          //     .map(c => c.customCharityId)
          //     .filter(id => !!id); // Avoid null/undefined

          //   this.customCharityCard.deleteItems(idsToDelete);
          // }
          // if (data['data']['totalCount'] == this.charities?.length)
            // this.showLoadMoreButton = false;
          this.charityLoading = false;
          const smallcards = data?.data?.smallCards;
          if (
            Array.isArray(smallcards) &&
            smallcards.length > 0 &&
            smallcards[smallcards.length - 1].isLastRecord
          ) {
            this.showLoadMoreButton = false;
          }
          else if( Array.isArray(smallcards) &&
            smallcards.length == 0){
             this.showLoadMoreButton = false;
          }
        } else {
          this.charityLoading=false;
          this.toastr.error(data['message'], "Error");
        }
      }, error => {
        this.charityLoading=false;
        this.toastr.error(error['message'], "Error");
      })
    )
}
  
loadMore(){
    this.page= this.page+1;
    this.loadingMoreCharity=true
    this.subscription.add(
      this.dataService.get(URLS.getCharities+`?page=${this.page}&size=${this.size}`).subscribe(data => {
        if (data['code'] == 200) {
           const merged = [...this.charities, ...data['data']['smallCards']];
          this.customCharityCard.setData(merged);
          const smallcards = data?.data?.smallCards;
          if (
            Array.isArray(smallcards) &&
            smallcards.length > 0 &&
            smallcards[smallcards.length - 1].isLastRecord
          ) {
            this.showLoadMoreButton = false;
          }
        // this.charities=[...this.charities, ...data['data']['smallCards']];
        // if(data['data']['totalCount']==this.charities?.length)
        // this.showLoadMoreButton=false;
        this.loadingMoreCharity=false
        } else {
          this.toastr.error(data['message'], "Error");
          this.loadingMoreCharity=false
        }
      }, error => {
        this.toastr.error(error['message'], "Error");
        this.loadingMoreCharity=false
      })
    )
  }

   preventSpaceInInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
  
    // Prevent leading space
    if (value.startsWith(' ')) {
      input.value = value.trimStart(); // Update the input field
      this.searchControl.setValue(input.value, { emitEvent: false }); // Update formControl without triggering valueChanges again
      this.searchText = input.value;
    }
  }

 
  onSearchInput(event: Event) {
  const input = event.target as HTMLInputElement;
  let value = input.value.trimStart(); // prevent leading space

  this.searchText = value;
  this.searchControl.setValue(value, { emitEvent: true }); // trigger valueChanges

  // Reset relevant fields
  this.orgId = '';
  this.charityForm.controls['city'].setValue(null);
  this.charityForm.controls['city'].enable();
  this.charityForm.controls['state'].setValue(null);
  this.charityForm.controls['state'].enable();
  this.charityForm.controls['organizationType'].setValue(null);
  this.charityForm.controls['organizationType'].enable();
  this.selectedOrganizationType = 'Select';
  this.organizationTypeId = null;
  this.addCharityOrgId = null;

   this.search$.next(value);
}
    selectOrganizationType(event: any, option: any) {
      event.stopPropagation();
      this.isOpen = false;
  
      this.selectedOrganizationType = option.name;
      this.organizationTypeId = option._id;
    }
  
    selectedCustomCharityAlldata
    selectCharityOption(event: any, option: any) {
      event.stopPropagation();
      if (option) {
        if (option.isAddedToCard) {

          const deletedItems = JSON.parse(localStorage.getItem('deletedItems') || '[]');

          const selectedId = option._id || option.orgId;
          const isAlreadyInList = deletedItems.some((item: any) => item.orgId === selectedId);

          if (!isAlreadyInList) {
            this.toastr.error(
              `This charity is already on your list. Each charity can only be added once.`,
              "Error"
            );
            return;
          }
        }
        this.searchText = option.orgName;
        this.searchTextVal = option.orgName;
        this.orgId = option._id;
        this.selectedCustomCharityAlldata=option;
        //  this.customCharityCard.setCardData(option);
        this.charityForm.controls['charityName'].setValue(option.orgName);
        this.charityForm.controls['city'].setValue(option.orgCity);
        if(option.orgCity)
        this.charityForm.controls['city'].disable();
        this.charityForm.controls['state'].setValue(option.orgState);
        if(option.orgState)
        this.charityForm.controls['state'].disable();
        this.charityForm.controls['organizationType'].setValue(option.orgType);
        if(option.orgType)
        this.charityForm.controls['organizationType'].disable();
        this.selectedOrganizationType = option['orgType'] ? option['orgType'] : 'Select';
        this.organizationTypeId = option['charitableCategoryId'];
        this.addCharityOrgId = option['_id'];
        console.log(option);
        // this.charityForm.controls['city']?.disable();
        // this.charityForm.controls['state']?.disable();
      }
  
      this.favCharityNameList = [];
    }


  getFavCharitySearch(dataParams?: any): Observable<{ results: any[], totalCount: number }> {
    const params = { ...(dataParams || {}), isCardAdded: true };
    this.searching = true;

    return this.dataService.get(URLS.favCharitySearch, params).pipe(
      map((data: any) => {
        const results = data['data']['result'] || [];
        const totalCount = data['data']['totalCount'] || 0;

        if (results.length === 0) this.showNoResult = true;
        else this.showNoResult = false;

        if (this.selectedCharitiesData) {
          const selectedOrgIds = new Set<string>();
          this.selectedCharitiesData.forEach(entry => {
            let row: any[] = [];
            if (Array.isArray(entry)) row = entry;
            else if (entry?.AddColumnData) row = entry.AddColumnData;

            const orgIdItem = row.find(item => item.label === 'orgId');
            if (orgIdItem?.answer) selectedOrgIds.add(orgIdItem.answer);
          });
          return { results: results.filter(item => !selectedOrgIds.has(item._id)), totalCount };
        }

        return { results, totalCount };
      }),
      finalize(() => {
        this.searching = false;
      }),
      catchError(err => {
        this.toastr.error(err['message'], 'Error');
        return of({ results: [], totalCount: 0 });
      })
    );
  }

    toggleDropdown(event: MouseEvent) {
      event.stopPropagation();
      this.isOpen = !this.isOpen;
    }

    isCharitySelected(charityId): boolean {
    //   // Flatten the 2D array into a single list of all entries
    //   const allAnswers = this.selectedCharitiesData.flat();
    // // console.log(this.selectedCharitiesData);
    //   // Find if any object has label === 'orgId' and matching answer
    //   return allAnswers.some(ans => ans.label === 'orgId' && ans.answer === charityId);
    if(this.selectedCharitiesData) {
    for (const entry of this.selectedCharitiesData) {
      let row: any[] = [];
  
      // Handle different structures: direct array or under AddColumnData
      if (Array.isArray(entry)) {
        row = entry;
      } else if (entry?.AddColumnData && Array.isArray(entry.AddColumnData)) {
        row = entry.AddColumnData;
      }
  
      // Search for matching orgId
      const orgIdItem = row.find(item => (item.label === 'customCharityId' || item.label === 'orgId') && item.answer === charityId);
      if (orgIdItem) {
        return true;
      }
    }
  }
}

// isCustomCharitySelected(charityId){
//   if(this.selectedCharitiesData) {
//     for (const entry of this.selectedCharitiesData) {
//       let row: any[] = [];
  
//       // Handle different structures: direct array or under AddColumnData
//       if (Array.isArray(entry)) {
//         row = entry;
//       } else if (entry?.AddColumnData && Array.isArray(entry.AddColumnData)) {
//         row = entry.AddColumnData;
//       }
  
//       // Search for matching orgId
//       const orgIdItem = row.find(item => item.label === 'customCharityId' && item.answer === charityId);
//       if (orgIdItem) {
//         return true;
//       }
//     }
//   }
// }


closeDropdown() {
  this.showNoResult = false;
  this.favCharityNameList = [];
}

reorderCharities(selectedCharitiesData: any[], charities: any[]): any[] {
  const matchedCharities: any[] = [];
  const matchedIds = new Set<string>();

  for (const entry of selectedCharitiesData) {
    let row: any[] = [];

    // Defensive checks to extract row data
    if (Array.isArray(entry)) {
      row = entry;
    } else if (entry?.AddColumnData && Array.isArray(entry.AddColumnData)) {
      row = entry.AddColumnData;
    } else {
      continue; // skip invalid entry
    }

    const idItem = row.find(item =>
      (item?.label === 'customCharityId' || (item?.label === 'orgId' && item.answer !== 'customCharity')) && !!item?.answer
    );

    const idToMatch = idItem?.answer;
    if (!idToMatch) continue;

    const match = charities.find(
      c => c?.customCharityId === idToMatch || c?.orgId === idToMatch
    );

    if (match && !matchedIds.has(match.customCharityId || match.orgId)) {
      matchedCharities.push(match);
      matchedIds.add(match.customCharityId || match.orgId);
    }
  }

  // Add remaining charities not matched
  const remaining = charities.filter(
    c => !matchedIds.has(c?.customCharityId || c?.orgId)
  );

  return [...matchedCharities, ...remaining];
}

  formatUrl(url: string): string {
    if (!url) {
      return '';
    }
    const trimmed = url.trim();
    if (/^https?:\/\//i.test(trimmed)) {
      return trimmed;
    }
    return 'https://' + trimmed;
  }

  @ViewChild('dropdownList') dropdownList!: ElementRef;
  onDropdownScroll(event: any) {
    const element = event.target;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
      this.scroll$.next();
    }
  }

  removeHtmlTags(input: string): string {
        if (typeof input !== 'string') {
            return ''; // Return an empty string or handle appropriately
        }
        if (input)
            return input.replace(/<\/?[^>]+(>|$)/g, '');
        return input
  }

  private wasLoading = false;

  ngAfterViewInit() {
    this.watchLoadingState();
    this.setupObservers();
  }

  ngOnDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => this.checkOverflow(), 50);
  }

  // Watch loading state changes
  private watchLoadingState() {
    const checkLoading = () => {
      // Detect transition: wasLoading=true → charityLoading=false
      if (this.wasLoading && !this.charityLoading) {
        this.checkOverflowAfterLoad();
      }
      this.wasLoading = this.charityLoading;
      
      // Continue watching
      setTimeout(checkLoading, 100);
    };
    checkLoading();
  }


  private checkOverflowAfterLoad(attempts = 0) {
    if (!this.charityDescEl?.nativeElement || attempts > 20) return;
    
    setTimeout(() => {
      this.checkOverflow();
      this.setupDynamicObservers();
    }, 100);
  }

  private setupObservers() {
    if (this.charityDescEl?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        setTimeout(() => this.checkOverflow(), 10);
      });
      this.resizeObserver.observe(this.charityDescEl.nativeElement);
    }
  }

  private setupDynamicObservers() {
    if (this.charityDescEl?.nativeElement && !this.mutationObserver) {
      this.mutationObserver = new MutationObserver(() => {
        setTimeout(() => this.checkOverflow(), 50);
      });
      this.mutationObserver.observe(this.charityDescEl.nativeElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  private checkOverflow() {
    if (this.charityLoading || !this.charityDescEl?.nativeElement) return;
    const el = this.charityDescEl.nativeElement;
    // Ensure clamped styles are applied
    el.classList.add('clamped');
    el.classList.remove('expanded');
    // Force browser reflow
    void el.offsetHeight;
    const hasOverflow = el.scrollHeight > el.clientHeight;

    this.showToggle = hasOverflow;
    
    if (!hasOverflow) {
      this.expanded = false;
    }
  }

  toggleExpansion() {
    this.expanded = !this.expanded;
  }
}



